import { Section } from '../../../components/ui/Section';
import { asRecord, str } from '../../../platform/api/utils';
import { fmtDate, inputCss, primaryBtn } from './task-detail.support';

// Aba Checklist do TaskDetail (régua de 400): estado e mutações ficam na página;
// aqui só a apresentação, com callbacks explícitos.
export function TaskChecklistTab(props: {
  items: unknown[];
  newLabel: string;
  onNewLabelChange: (value: string) => void;
  onAdd: () => void;
  adding: boolean;
  onToggle: (itemId: string, completed: boolean) => void;
  toggling: boolean;
  onRemove: (itemId: string) => void;
  removing: boolean;
}) {
  const {
    items,
    newLabel,
    onNewLabelChange,
    onAdd,
    adding,
    onToggle,
    toggling,
    onRemove,
    removing,
  } = props;
  return (
    <Section title="Lista de verificação">
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <input
          type="text"

          placeholder="Novo item..."

          value={newLabel}

          onChange={(e) => {
            onNewLabelChange(e.target.value);
          }}

          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onAdd();
            }
          }}

          style={{ flex: 1, ...inputCss }}
        />

        <button
          type="button"

          onClick={onAdd}

          disabled={!newLabel.trim() || adding}

          style={primaryBtn}
        >
          Adicionar
        </button>
      </div>

      {items.length === 0 ? (
        <p style={{ color: 'var(--faint)', fontSize: '0.875rem' }}>Nenhum item no checklist.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
          {items.map((raw) => {
            const item = asRecord(raw);

            const completed = !!item.completed;

            return (
              <div
                key={str(item.id)}

                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',

                  padding: '0.4rem 0.6rem',
                  borderRadius: 8,

                  background: completed ? 'var(--soft)' : 'transparent',
                }}
              >
                <input
                  type="checkbox"

                  checked={completed}

                  onChange={() => {
                    onToggle(str(item.id), completed);
                  }}

                  disabled={toggling}

                  style={{ cursor: 'pointer' }}
                />

                <span
                  style={{
                    flex: 1,
                    fontSize: '0.85rem',

                    textDecoration: completed ? 'line-through' : 'none',

                    color: completed ? 'var(--faint)' : 'var(--ink)',
                  }}
                >
                  {str(item.label)}
                </span>

                {completed && str(item.completedAt) && (
                  <span style={{ fontSize: '0.7rem', color: 'var(--faint)' }}>
                    {fmtDate(item.completedAt)}
                  </span>
                )}

                <button
                  type="button"

                  onClick={() => {
                    onRemove(str(item.id));
                  }}

                  disabled={removing}

                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--danger)',

                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    padding: '0.15rem 0.3rem',
                  }}
                >
                  ✕
                </button>
              </div>
            );
          })}
        </div>
      )}
    </Section>
  );
}
